import { useEffect } from 'react';

// The CRM's own drawers and modals, opened from the panel: the call drawer and the activity modal
// (WEB-15181), React or Angular. The app layers them at z-index 10000, under the panel's 100000,
// and lays them out for a desktop. They render outside the panel's shadow root, so this goes in
// the document. A hidden Angular modal keeps its own lower z-index, so it never blocks the panel.
// Repeated class names out-rank the app's own rules wherever they load: a lazily loaded chunk
// appends its CSS after this sheet, and an equal-specificity `.Modals` there would win.
const CSS = `
.Modals.Modals {
	z-index: 100001;
}
.Modals.Modals--ascended {
	z-index: 100002;
}
body > .up-modal {
	z-index: 100001;
}
.up-modal-curtain.up-modal-curtain {
	z-index: 100000;
}
/* Their select2 dropdowns, date pickers and tooltips hang off <body>. */
.select2-drop-mask.select2-drop-mask {
	z-index: 100003;
}
.select2-drop.select2-drop,
body > .dropdown-menu,
body > .popover,
body > .tooltip {
	z-index: 100004;
}
.Modals__modal--drawer.Modals__modal--drawer {
	max-width: 100vw;
}
.CreateCall .CreateCall__contentWrapper {
	width: 100%;
}

/* The activity modal's three columns, stacked: account and contact, the form, then the notes
   pinned above the buttons. Its header title sits under the user picker at this width. */
:is(.Modals .up-modal, body > .up-modal) .edit-activity-modal .up-modal-header-title-holder {
	visibility: hidden;
}
:is(.Modals .up-modal, body > .up-modal) .edit-activity-modal .sidebar-bg {
	display: none;
}
:is(.Modals .up-modal, body > .up-modal) .edit-activity-modal .modal-sidebar {
	float: none;
	width: auto;
	min-height: 0;
}
:is(.Modals .up-modal, body > .up-modal) .edit-activity-modal .up-modal-content.has-sidebar-x2 {
	bottom: 217px;
}
:is(.Modals .up-modal, body > .up-modal) .edit-activity-modal .up-modal-content.has-sidebar-x2 .modal-center {
	padding-left: 15px;
	padding-right: 15px;
}
:is(.Modals .up-modal, body > .up-modal) .edit-activity-modal .modal-sidebar.sidebar-right {
	position: absolute;
	inset: auto 0 57px 0;
	width: auto;
	height: 160px;
	padding: 0;
	background: #fff;
	border-top: 1px solid #e4eaf0;
}
`;

/** Lifts the CRM's drawers and modals above the panel, and fits them to it, while it is mounted. */
export default function useCrmFormsAbovePanel(enabled: boolean): void {
	useEffect(() => {
		if (!enabled) return;
		const style = document.createElement('style');
		style.textContent = CSS;
		document.head.appendChild(style);
		return () => style.remove();
	}, [enabled]);
}
